/** One problem, optionally with the details listed under it. */
type Entry = string | { text: string; lines: readonly string[] }

type Props = {
  heading?: string
  entries: readonly Entry[]
}

/**
 * What is wrong, as an error banner lists it: an optional heading line, then a bulleted list whose entries
 * may carry a nested list. Long unbroken backend text wraps instead of widening the banner.
 */
export function ErrorList({ heading, entries }: Props) {
  return (
    <div className="mt-1 wrap-anywhere">
      {heading ? <p>{heading}</p> : null}
      {entries.length > 0 ? (
        <ul className="list-disc ps-5">
          {entries.map((entry) =>
            typeof entry === 'string' ? (
              <li key={entry}>{entry}</li>
            ) : (
              <li key={entry.text}>
                {entry.text}
                {entry.lines.length > 0 ? (
                  <ul className="list-[circle] ps-5">
                    {entry.lines.map((line) => (
                      <li key={line}>{line}</li>
                    ))}
                  </ul>
                ) : null}
              </li>
            )
          )}
        </ul>
      ) : null}
    </div>
  )
}
